module.exports = __webpack_public_path__ + "img/leflategofx.d736c8dc.jpg";